import { LoadingScreen } from "@/components/LoadingScreen";
import { useAuth } from "@/hooks/useAuth";
import { useEffect, useRef, type ReactNode } from "react";

export function AuthGuard({ children }: { readonly children: ReactNode }) {
  const { isAuthenticated, error, user, login } = useAuth();
  const isLoginInProgressRef = useRef(false);

  useEffect(() => {
    if (isAuthenticated && !error) {
      isLoginInProgressRef.current = false;
      return;
    }

    // Refresh failures set a sticky Logto `error` and block the UI. Re-auth
    // (signIn clears tokens and navigates) recovers instead of a blank screen.
    if (!isLoginInProgressRef.current) {
      isLoginInProgressRef.current = true;
      void login(window.location.pathname);
    }
  }, [isAuthenticated, error, login]);

  if (!isAuthenticated || error) {
    return null;
  }

  if (!user) {
    return <LoadingScreen />;
  }

  return children;
}
